import { AlignType, EntityType, IComponent, ResizeOptions } from "@multiweb/picasso";
import { bridge } from "@multiweb/reactCore/bridge";
import { Set, Workflow } from "./workflowModel";
import { HEIGHT_OF_WF_SET, WIDTH_OF_WF_SET } from "./workflowModel/constants";

const { generateUUID } = bridge;

export class UiSet implements IComponent {
    public readonly id: string;
    public readonly index: number;
    public readonly type: EntityType = EntityType.component;
    public readonly linkIndexes: readonly number[];
    public readonly parent: number | null = null;
    public readonly children: readonly number[];
    public readonly name: string = "set";
    public readonly width: number = WIDTH_OF_WF_SET;
    public readonly minWidth: number = 100;
    public readonly height: number = HEIGHT_OF_WF_SET;
    public readonly minHeight: number = 100;
    public readonly relativeTop: number = 0;
    public readonly relativeLeft: number = 0;
    public readonly set: Set;
    public readonly workflow: Workflow;
    public readonly isVisible: boolean = true;
    public readonly align: AlignType = AlignType.none;
    public readonly resizeOption: ResizeOptions = ResizeOptions.none;
    public readonly noCssHeight?: boolean | undefined;

    constructor(index: number, childrenIndexes: number[], linkIndexes: number[], set: Set, workflow: Workflow) {
        this.id = generateUUID();
        this.index = index;
        this.children = childrenIndexes;
        this.set = set;
        this.linkIndexes = linkIndexes;
        this.workflow = workflow;
    }
}
